import request from "./request";
import { API_Salesorderprepay } from "../interfaces";

const addPrepayDish = async (values: API_Salesorderprepay) => {
  try {
    const resp = await request.post("/api/v1/order/salesorderprepay", values);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};

export default addPrepayDish;
